module.exports = __webpack_public_path__ + "img/bg_6.8565d21f.jpg";